module.exports = __webpack_public_path__ + "static/media/ic_send_disabled.0b61433f.svg";